export const VARIANTS = [
  'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'
]

export const VARIANT_COLORS = {
  primary:   { bg: '#495057', text: '#fff', border: '#3a4047', light: 'rgba(73,80,87,0.12)' },
  secondary: { bg: '#3DF9DE', text: '#212529', border: '#0ce6c9', light: 'rgba(61,249,222,0.18)' },
  success:   { bg: '#34C38F', text: '#fff', border: '#2ca67a', light: 'rgba(52,195,143,0.15)' },
  danger:    { bg: '#F46A6A', text: '#fff', border: '#f03b3b', light: 'rgba(244,106,106,0.15)' },
  warning:   { bg: '#F1B44C', text: '#212529', border: '#eda41d', light: 'rgba(241,180,76,0.18)' },
  info:      { bg: '#50A5F1', text: '#fff', border: '#218cf0', light: 'rgba(80,165,241,0.15)' },
  light:     { bg: '#f8f9fa', text: '#212529', border: '#dae0e5', light: 'rgba(248,249,250,0.5)' },
  dark:      { bg: '#343a40', text: '#fff', border: '#1d2124', light: 'rgba(52,58,64,0.18)' }
}

export function variantStyle(variant, outline) {
  const c = VARIANT_COLORS[variant] || VARIANT_COLORS.primary
  if (outline) {
    return {
      color: c.border,
      backgroundColor: 'transparent',
      borderColor: c.border,
      '--hover-bg': c.light,
      '--hover-color': c.border
    }
  }
  return {
    color: c.text,
    backgroundColor: c.bg,
    borderColor: c.border,
    '--hover-bg': c.border,
    '--hover-color': c.text
  }
}
